import {useGetAgentHostsV3} from '@/features/agent/queries/useGetAgentHostsV3'
import {useMe} from '@/features/authentication/queries/useMe'
import {useGetRepresentativeHostsV3} from '@/features/representative/queries/useGetRepresentativeHostsV3'
import {useRootStore} from '@/store'
import {selectChatStore} from '@/store/selectors'
import {UserRoleE} from '@/types'
import {LocalStorageManager} from '@/utilities/localStorage'
import {useMemo} from 'react'

export const useGetRepresentedUser = (enabled = true) => {
    const {data: user} = useMe(enabled)
    const {needReInitAfterChangedRepresentedHost} = useRootStore(selectChatStore)
    const isRepresentative = user?.type === UserRoleE.Representative
    const isAgent = user?.type === UserRoleE.Agent
    const {data: agentHosts, isLoading: isLoadingAgentHosts} = useGetAgentHostsV3(isAgent && enabled)
    const {data: representativeHosts, isLoading: isLoadingRepresentativeHosts} = useGetRepresentativeHostsV3(
        isRepresentative && enabled
    )
    const agentAndRepsHosts = agentHosts ?? representativeHosts ?? []

    const representedUserId = useMemo(() => {
        return LocalStorageManager.chatUserId.get() ?? agentAndRepsHosts[0]?.id
    }, [needReInitAfterChangedRepresentedHost, agentAndRepsHosts])

    const representedUser = useMemo(() => {
        if (!representedUserId) return undefined

        const correctUser = agentAndRepsHosts.find(item => {
            if (user?.type === UserRoleE.Agent) {
                return item.id === +representedUserId
            }
            if (user?.type === UserRoleE.Representative) {
                return 'rookieId' in item && item.rookieId === +representedUserId
            }
            return false
        })

        return correctUser
    }, [representedUserId, agentAndRepsHosts, needReInitAfterChangedRepresentedHost, user?.type])

    const isLoading = isLoadingAgentHosts || isLoadingRepresentativeHosts

    return {representedUser, isLoading, agentAndRepsHosts, representedUserId}
}
